module.exports = __webpack_public_path__ + "img/bottle.7616422c.png";